import * as ComponentReact from 'react'
import styled from 'styled-components'

import { elementStyle } from 'styles/element-style'
import { flexItemStyle } from 'styles/flex-item-style'

interface Props extends IElement, IFlexItem, ComponentReact.HTMLAttributes<HTMLDivElement> {
  className?: string
}

const StyledDiv = styled.div<Props>`
  ${elementStyle}
  ${flexItemStyle}
`

export const Div = ComponentReact.forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  ({ children, ...props }, ref) => (
    <StyledDiv ref={ref} {...props}>
      {children}
    </StyledDiv>
  ),
)
